import React from 'react'
import styled from 'styled-components'

import trinaImage from '../../images/trina-vargo.jpg'

const StyledImage = styled.img`
  border-radius: 4px;
  display: block;
  height: auto;
  width: 100%;
`

const TrinaImage = () => (
  <StyledImage src={trinaImage} alt="Author Trina Vargo" loading="lazy" />
)

export default TrinaImage
